import {Component, EventEmitter, Input, OnInit, Output, Inject} from "@angular/core";
import { RESTANGULAR_SETTINGS } from '@app/common/services/restangular-settings.service';
import {TableService} from "@app/ps/services/table.service";
import {SettingsService} from "@app/ps/services/settings.service";
import {UserNamePipe} from "@app/common/pipes/username.pipe";
import { User } from '@app/models/user';
import {OpinionRequestService} from "@app/ps/services/opinion-request.service";
import {OpinionRequestModel} from "@app/ps/models/opinion-request.model";
import {Restangular} from "ngx-restangular";
import { AuthService } from '@app/common/services/auth.service';

@Component({
  selector: 'table-construction-object',
  templateUrl: './table-construction-object.component.html',
})
export class TableConstructionObjectComponent implements OnInit {
  @Input() list: any;
  @Input() clickable = false;
  @Output() sort = new EventEmitter();
  @Output() onclick = new EventEmitter();
  userSending: any = {};
  users: User[];

  constructor(
    @Inject(RESTANGULAR_SETTINGS) private restangularSettings: any,
    private tableService: TableService,
    private settingsService: SettingsService,
    public userNamePipe: UserNamePipe,
    public requestService: OpinionRequestService,
    private restangular: Restangular,
    private authService: AuthService,
  ) {
    this.onUpdateUser = this.onUpdateUser.bind(this);
  }

  private readonly TABLE_ID = 'constructionObjects';
  public isArray = Array.isArray;

  ngOnInit() {
    if (!this.hideColumn('mandatary')) {
      this.loadUsers();
    }
  }

  onClick(opinion: OpinionRequestModel) {
    this.onclick.emit(opinion);
  }

  onSort(column: string, ascOrDesc: string) {
    this.sort.emit({
      column,
      ascOrDesc,
    });
  }

  hideColumn(columnId: string): boolean {
    return this.settingsService.shouldHideColumn(this.TABLE_ID, columnId);
  }

  getColumnName(columnId: string): string {
    return this.tableService.getColumnById(this.TABLE_ID, columnId).name;
  }

  onUpdateUser(constructionObjectId, userId) {
    this.userSending[constructionObjectId] = true;

    this.restangular.one('construction-objects', constructionObjectId).customPUT({ id: userId }, 'user').toPromise().then(() => {
      this.userSending[constructionObjectId] = false;
    });
  }

  private loadUsers() {
      const filter = {
        filters: {
          searchText: {
            values: [],
          },
          applications: {
            values: [this.authService.getActiveApplication()],
          },
          permission: {
            values: ['assignable'],
          },
          projects: {
            values: [this.authService.getActualProject().key],
          },
        },
        sortOrder: [
          { sortBy: 'surname' },
          { sortBy: 'name' },
        ],
      };
      this.restangularSettings.all('users/list').customPOST({ filter: filter }).toPromise().then((data) => {
        this.users = data;
      });
    }
}
